import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, vShow as _vShow, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-031120a5")

_pushScopeId("data-v-031120a5")
const _hoisted_1 = { class: "flex items-center gap-5" }
const _hoisted_2 = { class: "flex flex-col gap-x-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "grid gap-6 grid-cols-6" }
const _hoisted_5 = {
  class: "w-full flex flex-row justify-between items-center bg-aqua-lp-200 rounded-md border-2 border-dashed py-3 px-4",
  style: {"border-color":"#47a1bc"}
}
const _hoisted_6 = { class: "text-gray-lp-300 text-14px" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Anda bisa menggabungkan STT tujuan ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ke BAGGING tujuan ")
const _hoisted_9 = { class: "grid gap-6 grid-cols-3 items-end" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_11 = {
  class: "grid grid-cols-5 gap-5 py-3 px-5 bg-gray-lp-1000 border border-gray-lp-1400",
  style: {"border-radius":"20px 20px 0 0"}
}
const _hoisted_12 = { class: "text-gray-lp-300" }
const _hoisted_13 = { class: "font-semibold text-20px" }
const _hoisted_14 = { class: "font-normal" }
const _hoisted_15 = { class: "text-gray-lp-300" }
const _hoisted_16 = { class: "font-semibold text-20px" }
const _hoisted_17 = { class: "text-gray-lp-300" }
const _hoisted_18 = { class: "font-semibold text-20px" }
const _hoisted_19 = { class: "text-gray-lp-300" }
const _hoisted_20 = { class: "font-semibold text-20px" }
const _hoisted_21 = { class: "text-gray-lp-300" }
const _hoisted_22 = { class: "font-semibold text-20px text-blue-lp-70 text-blue-lp-700" }
const _hoisted_23 = {
  class: "grid grid-cols-5 items-stretch gap-5 py-3 px-5 border border-gray-lp-1400",
  style: {"border-radius":"0 0 20px 20px"}
}
const _hoisted_24 = { class: "text-gray-lp-300" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-100" }, "*", -1)
const _hoisted_26 = { style: {"margin-top":"1px"} }
const _hoisted_27 = { class: "col-span-2" }
const _hoisted_28 = { class: "text-gray-lp-300 mb-2" }
const _hoisted_29 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-100" }, "*", -1)
const _hoisted_31 = {
  key: 0,
  class: "text-blue-lp-700 mt-2 flex items-center gap-1"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.43165 2.78909C8.12015 1.56509 9.88145 1.56509 10.5691 2.78909L15.5911 11.7171C16.2661 12.9177 15.3994 14.3991 14.0233 14.3991H3.97835C2.60135 14.3991 1.73465 12.9177 2.40965 11.7171L7.43165 2.78909ZM9.90035 11.7C9.90035 11.9387 9.80553 12.1676 9.63675 12.3364C9.46797 12.5052 9.23905 12.6 9.00035 12.6C8.76166 12.6 8.53274 12.5052 8.36396 12.3364C8.19517 12.1676 8.10035 11.9387 8.10035 11.7C8.10035 11.4613 8.19517 11.2324 8.36396 11.0636C8.53274 10.8948 8.76166 10.8 9.00035 10.8C9.23905 10.8 9.46797 10.8948 9.63675 11.0636C9.80553 11.2324 9.90035 11.4613 9.90035 11.7ZM9.00035 4.49999C8.76166 4.49999 8.53274 4.59482 8.36396 4.7636C8.19517 4.93238 8.10035 5.1613 8.10035 5.39999V8.09999C8.10035 8.33869 8.19517 8.56761 8.36396 8.73639C8.53274 8.90517 8.76166 8.99999 9.00035 8.99999C9.23905 8.99999 9.46797 8.90517 9.63675 8.73639C9.80553 8.56761 9.90035 8.33869 9.90035 8.09999V5.39999C9.90035 5.1613 9.80553 4.93238 9.63675 4.7636C9.46797 4.59482 9.23905 4.49999 9.00035 4.49999Z",
    fill: "#2468F6"
  })
], -1)
const _hoisted_33 = { class: "text-gray-lp-300" }
const _hoisted_34 = { class: "font-semibold text-20px mt-2" }
const _hoisted_35 = { class: "text-gray-lp-300" }
const _hoisted_36 = {
  key: 0,
  class: "text-red-lp-100"
}
const _hoisted_37 = {
  key: 1,
  class: "text-red-lp-100"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "relative" }
const _hoisted_40 = { class: "\n          px-10\n          flex-col\n          grid\n          col-gap-2\n          grid-cols-8\n          justify-center\n          w-full\n          mt-2\n        " }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_42 = { class: "col-span-4 space-y-1" }
const _hoisted_43 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_45 = { class: "text-12px text-black-lp-300" }
const _hoisted_46 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_47 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_48 = { class: "text-12px text-black-lp-300" }
const _hoisted_49 = { class: "flex flex-row" }
const _hoisted_50 = { class: "flex flex-col space-y-3" }
const _hoisted_51 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_52 = { class: "space-y-1" }
const _hoisted_53 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_54 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_55 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_56 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_57 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_58 = { class: "flex justify-end space-x-3" }
const _hoisted_59 = {
  class: "flex flex-col items-center gap-4",
  style: {"width":"400px"}
}
const _hoisted_60 = {
  key: 0,
  class: "text-white bg-red-lp-100 rounded-full px-4 py-1 font-bold"
}
const _hoisted_61 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_62 = { class: "w-full flex flex-col gap-2 text-sm text-gray-lp-300" }
const _hoisted_63 = { class: "flex flex-row justify-between" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", null, "No. STT", -1)
const _hoisted_65 = { class: "font-semibold" }
const _hoisted_66 = { class: "flex flex-row justify-between" }
const _hoisted_67 = { class: "font-semibold" }
const _hoisted_68 = { class: "flex flex-row justify-between" }
const _hoisted_69 = { class: "font-semibold" }
const _hoisted_70 = { class: "flex flex-row justify-between" }
const _hoisted_71 = { class: "font-semibold" }
const _hoisted_72 = { class: "flex flex-row justify-between" }
const _hoisted_73 = { class: "font-semibold" }
const _hoisted_74 = { class: "flex flex-row justify-between" }
const _hoisted_75 = { class: "font-semibold" }
const _hoisted_76 = { class: "flex flex-row justify-between" }
const _hoisted_77 = { class: "font-semibold" }
const _hoisted_78 = { class: "w-full flex flex-row pb-3" }
const _hoisted_79 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_NotificationCommodityGrouping = _resolveComponent("NotificationCommodityGrouping")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ScanFlagIllustration = _resolveComponent("ScanFlagIllustration")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('Buat Bagging'),
      "vertical-separator": false,
      fullPage: "",
      "is-floating-action": ""
    }, {
      "top-right": _withId(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.isShowRTC)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [_ctx.labelToggleRTC.style, "border border-1 flex items-center justify-center gap-2 py-2 px-3 rounded-full font-medium"]
              }, [
                _createVNode("div", null, _toDisplayString(_ctx.labelToggleRTC.text), 1),
                _createVNode(_component_Toggle, {
                  modelValue: _ctx.form.isRTC,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.isRTC = $event)),
                  customLabel: true,
                  styleActive: "bg-green-lp-400"
                }, null, 8, ["modelValue"])
              ], 2))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(_component_LpButton, {
              onClick: _cache[2] || (_cache[2] = (e) => !_ctx.isDisableProcess && _ctx.togglePanel(e)),
              icon: _ctx.chevron ? 'chevron-up-white' : 'chevron-down-white',
              title: _ctx.$t('Process'),
              textColor: "white",
              class: "whitespace-no-wrap",
              disabled: _ctx.isDisableProcess
            }, null, 8, ["icon", "title", "disabled"]), [
              [_directive_click_outside, () => (_ctx.chevron = false)]
            ]),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withId(() => [
                _createVNode(_component_LpButton, {
                  class: "w-60",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAndPrint(false))),
                  flat: "",
                  dense: "",
                  iconLeft: "bagging-list",
                  title: _ctx.$t('Buat Bagging')
                }, null, 8, ["title"]),
                _hoisted_3,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createAndPrint(true))),
                  flat: "",
                  dense: "",
                  iconLeft: "printer",
                  title: _ctx.$t('Buat Bagging & Print Label')
                }, null, 8, ["title"])
              ]),
              _: 1
            }, 512)
          ])
        ])
      ]),
      data: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Kota Tujuan'),
            class: "col-span-2"
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                class: "my-2",
                onFilter: _ctx.fetchDestinationCity,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRegionBaggingGrouping(_ctx.form.destinationCity?.code))),
                isLoading: _ctx.isLoadingDestinationCity,
                options: _ctx.destinationCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: _ctx.$t('Pilih kota tujuan'),
                modelValue: _ctx.form.destinationCity,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.destinationCity = $event))
              }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        (_ctx.showRecommendationRegion)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              style: {"width":"66%"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Icons, {
                    width: "18",
                    height: "18",
                    class: "mr-2",
                    name: "warning-circle",
                    color: "#47a1bc"
                  }),
                  _createVNode("p", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("strong", null, _toDisplayString(_ctx.form.destinationCity?.name), 1),
                    _hoisted_8,
                    _createVNode("strong", null, _toDisplayString(_ctx.regionBaggingGrouping.baggingRegionDestinationId) + " - " + _toDisplayString(_ctx.regionBaggingGrouping.baggingRegionDestinationName), 1)
                  ]),
                  _createVNode(_component_Icons, {
                    onClick: _cache[7] || (_cache[7] = () => (_ctx.showNotesDestination = false)),
                    width: "12",
                    height: "12",
                    name: "icon-x",
                    class: "cursor-pointer ml-6",
                    color: "#A7A8AA"
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('No. STT')
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                ref: "inputStt",
                error: _ctx.errorSttNumber !== '' || _ctx.isUnpaid || _ctx.isDiffDestination,
                onChange: _ctx.onCloseNotification,
                isErrorIconInput: false,
                isErrorIconCaption: "",
                errorCaption: _ctx.$t(_ctx.errorSttNumber),
                onEnter: _ctx.addScanSttNumber,
                sizeInput: "24px",
                labelStacked: _ctx.$t('bagging.placeholderAdd'),
                modelValue: _ctx.form.sttNumber,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.sttNumber = $event)),
                placeholder: _ctx.$t('bagging.secondPlaceholderAdd'),
                bold: !!_ctx.form.sttNumber
              }, null, 8, ["error", "onChange", "errorCaption", "onEnter", "labelStacked", "modelValue", "placeholder", "bold"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_LpButton, {
            onClick: _cache[9] || (_cache[9] = () => _ctx.addSttNumber()),
            customClass: `px-12 py-2.5 ${_ctx.errorSttNumber !== '' || _ctx.isUnpaid || _ctx.isDiffDestination ? 'mb-8' : 'mb-4'}`,
            title: _ctx.$t('Tambah'),
            textColor: "white",
            disabled: _ctx.isDisableAddSttNumber
          }, null, 8, ["customClass", "title", "disabled"]),
          (_ctx.scanFailedList.length)
            ? (_openBlock(), _createBlock(_component_ScanFailedCard, {
                key: 0,
                data: _ctx.scanFailedList
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.dataSttToBeCreate.length > 0 && !_ctx.isFailed)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_10,
              _createVNode("div", null, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("Total STT (koli)")), 1),
                    _createVNode("div", _hoisted_13, [
                      _createTextVNode(_toDisplayString(`${_ctx.totalStt}`) + " ", 1),
                      _createVNode("span", _hoisted_14, _toDisplayString(`(${_ctx.totalPieces || 0})`), 1)
                    ])
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("STT DG")), 1),
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.totalDangerousGoods || 0), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("bagging.totalSttGrossWeight")), 1),
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("bagging.totalSttVolumeWeight")), 1),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.formatWeight(_ctx.totalVolumeWeight)), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("Total Chargeable weight STT")), 1),
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatWeight(_ctx.sttChargeableWeight)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Berat Kotor Bag")), 1),
                      _hoisted_25
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode(_component_lp_input, {
                        "data-testid": "outgoing-bagging-input-gross-weight",
                        onChange: _ctx.onChangeWeight,
                        isErrorIconInput: false,
                        suffix: "Kg",
                        modelValue: _ctx.form.weight,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.weight = $event)),
                        format: _ctx.numberOnly,
                        error: _ctx.isErrorGrossWeight,
                        errorCaption: _ctx.$t('Berat kotor bag wajib diisi'),
                        onBlur: _ctx.onBlurGrossWeight
                      }, null, 8, ["onChange", "modelValue", "format", "error", "errorCaption", "onBlur"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Dimensi Bag")) + " ", 1),
                      _createVNode("span", _hoisted_29, " " + _toDisplayString(_ctx.$t("(P x L x T)")), 1),
                      _hoisted_30
                    ]),
                    _createVNode(_component_InputDimension, {
                      "data-testid": "outgoing-bagging-input-dimension",
                      length: _ctx.form.length,
                      "onUpdate:length": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.length = $event)),
                      width: _ctx.form.width,
                      "onUpdate:width": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.width = $event)),
                      height: _ctx.form.height,
                      "onUpdate:height": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.height = $event)),
                      withIcon: false,
                      error: _ctx.isErrorDimension,
                      errorCaption: _ctx.$t('Dimensi wajib diisi'),
                      format: _ctx.formatNoDecimal,
                      onInput: _ctx.changeDimension
                    }, null, 8, ["length", "width", "height", "error", "errorCaption", "format", "onInput"]),
                    (_ctx.isDimensionChange)
                      ? (_openBlock(), _createBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode("span", null, _toDisplayString(_ctx.$t("bagging.editDimensionInfo")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("bagging.volumeWeightBag")), 1),
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formatWeight(Number(_ctx.totalBagVolumeWeight))), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("bagging.chargeableWeightBag")), 1),
                    _createVNode("div", {
                      class: `font-semibold text-20px mt-2 ${(_ctx.bagWeightOverSttWeight && _ctx.isValidationPhotoProofHasPermission) || _ctx.isMaxWeightDispute ? 'text-red-lp-100' : 'text-blue-lp-700'}`
                    }, _toDisplayString(_ctx.formatWeight(_ctx.bagChargeableWeight)), 3),
                    (_ctx.bagWeightOverSttWeight && _ctx.isValidationPhotoProofHasPermission && !_ctx.isMaxWeightDispute)
                      ? (_openBlock(), _createBlock("div", _hoisted_36, _toDisplayString(_ctx.$t("bagging.errorBagExceed")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isMaxWeightDispute)
                      ? (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.$t('Selisih berat maks.')) + " " + _toDisplayString(_ctx.maxWeightDispute) + " kg ", 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.isValidationAdjustWeightProofPhotoEnable && _ctx.isValidationPhotoProofHasPermission)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode(_component_SectionUploadPhotoForWeightAdjusment, {
                      marginBottom: false,
                      defaultOpened: true,
                      modelValue: _ctx.photoProof,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.photoProof = $event)),
                      showViewAdjustment: _ctx.openAdjustmentWeight,
                      "onUpdate:showViewAdjustment": _cache[15] || (_cache[15] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                      onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                      onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                      onShowViewAdjustment: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight))
                    }, null, 8, ["modelValue", "showViewAdjustment", "onOnUploadImage", "onOnDeleteImage"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_39, [
                _createVNode(_component_TableV2, {
                  data: _ctx.dataSttToBeCreate,
                  columns: _ctx.columns,
                  deleteAction: true,
                  isRightFreeze: "",
                  totalColumnFreeze: 1,
                  onDeleteItem: _ctx.onDeleteSttItem,
                  borderTop: false,
                  pagination: _ctx.pagination,
                  "is-hard-pagination": true,
                  "is-quick-search": true,
                  "is-sorting": true,
                  "pagination-style": "v2"
                }, null, 8, ["data", "columns", "onDeleteItem", "pagination"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.isPartial || _ctx.isFailed ? 'Download' : 'OK',
      textCancel: _ctx.isPartial || _ctx.isFailed ? 'OK' : '',
      class: "px-8 create-bagging",
      customButton: _ctx.isPartial ? 'px-10' : 'px-6'
    }, {
      custom: _withId(() => [
        _createVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode("div", _hoisted_42, [
            _withDirectives(_createVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode("div", _hoisted_45, _toDisplayString(_ctx.countSuccess) + " " + _toDisplayString(_ctx.$t("No. STT Sukses")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode("div", _hoisted_48, _toDisplayString(_ctx.countFailed) + " " + _toDisplayString(_ctx.$t("No. STT Gagal")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, _ctx.openSuccess || _ctx.isErrorTyping || _ctx.isFailed || _ctx.isPartial]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar?'),
      message: 
      _ctx.$t(
        'Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'
      )
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onShowLoadingSave,
      onClose: _ctx.handleConfirmationSave,
      title: 
      `${
        _ctx.form.isRTC
          ? _ctx.$t('bagging.rtcBaggingConfirmationTitle')
          : _ctx.$t('bagging.baggingConfirmationTitle')
      }`
    ,
      message: 
      `${
        _ctx.form.isRTC
          ? _ctx.$t('bagging.rtcBaggingConfirmationMessage')
          : _ctx.$t('Pastikan kembali, seluruh detail STT sudah benar dan sesuai.')
      }`
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('bagging.buttonProcessBagging'),
      textCancel: _ctx.$t('Batal'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _createVNode(_component_Notification, {
      titleMessageError: 
      _ctx.isErrorBagging
        ? _ctx.$t('No. STT tidak dapat di booking bagging')
        : _ctx.$t('STT number cannot be updated')
    ,
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.notification = $event)),
      status: _ctx.isErrorNotification ? 'error' : 'success',
      onClose: _ctx.onCloseNotification,
      messageError: _ctx.messageErrorNotification
    }, null, 8, ["titleMessageError", "data", "modelValue", "status", "onClose", "messageError"]),
    _createVNode(_component_NotificationCommodityGrouping, {
      data: _ctx.detailNotificationCommodityGrouping,
      modelValue: _ctx.notificationCommodityGrouping,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.notificationCommodityGrouping = $event)),
      onClose: _ctx.onCloseNotification,
      message: _ctx.detailNotificationCommodityGrouping?.message,
      customIcon: "warning-triangle",
      iconColor: "text-yellow-lp-500"
    }, null, 8, ["data", "modelValue", "onClose", "message"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_49, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("Hapus Barang")), 1),
            _createVNode("div", _hoisted_52, [
              _withDirectives(_createVNode("div", _hoisted_53, null, 512), [
                [_directive_sanitize_html, 
              _ctx.$t(
                'Masukan No. STT atau Scan Barcode/QR Code untuk<br />barang yang ingin dihapus dari daftar Bagging.'
              )
            ]
              ]),
              _createVNode(_component_LpInput, {
                error: _ctx.errorSttNumberDelete !== '',
                errorCaption: _ctx.errorSttNumberDelete,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.sttNumberToDelete = $event)),
                onEnter: _ctx.onDeleteSttNumber,
                ref: "deleteStt"
              }, null, 8, ["error", "errorCaption", "modelValue", "onEnter"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("Terhapus")), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_56,
                      _createVNode("div", _hoisted_57, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_58, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('Batal'),
            class: "mt-10"
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            disabled: _ctx.sttNumberToDelete === '',
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('Hapus'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.alertDangerousGoods,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.alertDangerousGoods = $event)),
      header: false
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_59, [
          _createVNode(_component_ScanFlagIllustration, {
            data: _ctx.detailSttNotification,
            variant: "bagging"
          }, null, 8, ["data"]),
          (_ctx.detailSttNotification.isDangerousGoods && !_ctx.detailSttNotification.isWoodpacking)
            ? (_openBlock(), _createBlock("div", _hoisted_60, "DANGEROUS GOODS"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_61, _toDisplayString(_ctx.$t("bagging.successAddSttNumber")), 1),
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode("div", _hoisted_65, _toDisplayString(_ctx.detailSttNotification.sttNumber), 1)
            ]),
            _createVNode("div", _hoisted_66, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.destinationCity")), 1),
              _createVNode("div", _hoisted_67, _toDisplayString(_ctx.detailSttNotification.cityId) + " - " + _toDisplayString(_ctx.detailSttNotification.cityName), 1)
            ]),
            _createVNode("div", _hoisted_68, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.tableTitle.serviceType")), 1),
              _createVNode("div", _hoisted_69, _toDisplayString(_ctx.detailSttNotification.product), 1)
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.woodpacking")), 1),
              _createVNode("div", _hoisted_71, _toDisplayString(_ctx.detailSttNotification.woodpacking ? _ctx.$t("bagging.yes") : _ctx.$t("bagging.no")), 1)
            ]),
            _createVNode("div", _hoisted_72, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.commodity")), 1),
              _createVNode("div", _hoisted_73, _toDisplayString(_ctx.detailSttNotification.commodity), 1)
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.totalPieces")), 1),
              _createVNode("div", _hoisted_75, _toDisplayString(_ctx.detailSttNotification.totalPieces), 1)
            ]),
            _createVNode("div", _hoisted_76, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bagging.CodAmount")), 1),
              _createVNode("div", _hoisted_77, _toDisplayString(_ctx.detailSttNotification.codAmount
                ? _ctx.formatCod(_ctx.detailSttNotification.codAmount)
                : "-"), 1)
            ])
          ]),
          _createVNode("div", _hoisted_78, [
            _createVNode(_component_LpButton, {
              title: "Oke",
              textColor: "white",
              isWidthFull: "",
              onClick: _ctx.onConfirmDangerousGoods,
              onEnter: _ctx.onConfirmDangerousGoods
            }, null, 8, ["onClick", "onEnter"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_79, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
})